import { createAction, props } from '@ngrx/store';

export const setCustomExpirationDate = createAction(
  '[Cart] Set Custom Expiration Date',
  props<{ customExpirationDate: string }>(),
);
